"use client";
import { useEffect, useState, useCallback } from "react";
import { useAtom } from "jotai";
import SVG from "react-inlinesvg";
import Pagination from "@/components/utils/Pagination";
import { useParams, useSearchParams, useRouter } from "next/navigation";
import NewsList from "@/components/utils/NewsList";

import Link from "next/link";

export default function PageComponent({ posts, categories, tags ,selectCategory, selectTag}) {
  // console.log(posts,categories,tags);

  const router = useRouter();
  const itemsPerPage = 20;
  const [itemOffset, set_itemOffset] = useState(0);
  const [pageNum, set_pageNum] = useState(null);
  const [isTagOpen, set_isTagOpen] = useState(false);
  

  // ページネーションをセットする
  useEffect(() => {
    const currentPage = itemOffset / itemsPerPage + 1;
    const {pathname,searchParams} = new URL(location.href);
    const url = itemOffset == 0 ? pathname : `?page=${currentPage}`
    router.replace(url);
  }, [itemOffset]);

  // 初回のカレントページ取得
  useEffect(() => {
    const {searchParams}=new URL(location.href);
    const page = ~~searchParams.get("page")||1;
    set_pageNum(page)
    set_itemOffset((page - 1) * itemsPerPage);
  }, []);
  // const createQueryString = useCallback(
  //   (name: string, value: string) => {
  //     const params = new URLSearchParams(searchParams.toString())
  //     params.set(name, value)
  //     return params.toString()
  //   },
  //   [searchParams]
  // );

  // console.log(searchParams);
  // const



  
  

  return (
    <main className="page page-news-index">
      <div className="container-m">
        <div className="page-title-holder">
          <h1 className="h1-title">
            <span className="shoulder">お知らせ</span>
            <span className="title en">News</span>
          </h1>
        </div>
        <div className="grid-3-col">
          <div className="news-category-list-block">
            <div className="news-category-list">
              <Link href={"/news/"} className={`news-category-list-item scaleHover ${!selectCategory ? "current" : ""}`}>
                <span className="inner">
                  すべて
                </span>
              </Link>
              {categories &&
                categories.map(({ title, slug }, i) => (
                  <Link href={`/news/${slug}/`} key={i} className={`news-category-list-item scaleHover ${selectCategory == slug ? "current" : ""}`}>
                    <span className="inner">
                      {title}
                    </span>
                  </Link>
                ))}
            </div>

            {/* 活動実績、メディア掲載の場合 */}
            {tags.length>0 && (selectCategory=="implementation"||selectCategory=="media") &&
              <div className="news-tag-list-container">
                <div className={`news-tag-list ${isTagOpen?"open":""}`}>
                  <button className="news-tag-list-item default" type="button" onClick={() => set_isTagOpen(prev => !prev)}>
                    {isTagOpen || !selectTag ? (
                      <span className="default">
                        タグで絞り込み
                      </span>
                    ):(
                      tags && tags.map(({ title,slug }, i) => (
                        selectTag == slug && (
                          title
                        )
                      ))
                    )}
                  </button>
                  <div className="accordion-content">
                    <div className="accordion-content-inner">
                      {tags &&
                        tags.map(({ title,slug }, i) => (
                        <Link href={`/news/${selectCategory}/${slug}/`} key={i} className={`news-tag-list-item ${selectTag == slug ? "current" : ""}`} onClick={() => {
                          if(selectTag == slug) {
                            set_isTagOpen(false)
                          }
                        }}>
                          {title}
                        </Link>
                      ))}
                    </div>
                  </div>
                  <i className="icon-select">
                    <SVG src="/assets/img/common/icon/icon-arrow-bottom.svg" />
                  </i>
                </div>
              </div>
            }
            
          </div>
          <div className="news-list-block">
            <NewsList posts={posts} itemOffset={itemOffset} itemsPerPage={itemsPerPage} />
            {pageNum!==null && <Pagination className="pagination" defaultCurrent={pageNum} itemsPerPage={itemsPerPage} items={posts} set_itemOffset={set_itemOffset} />}
          </div>
        </div>
      </div>
    </main>
  );
}
